export default defineNuxtPlugin(async (nuxtApp) => {
  const { oneTrustId, enableUnbounce, enableOptimize, enableTracify } = nuxtApp.$config.public;
  const { locale } = nuxtApp.$i18n;

  const scripts = [];

  // check if we are in a Storybook environment
  const isStorybook =
    typeof window !== 'undefined' &&
    (window.__STORYBOOK_CLIENT_API__ || window.__STORYBOOK_ADDONS_CHANNEL__ || window.parent !== window);

  if (oneTrustId && !isStorybook) {
    // Add CSS to hide OneTrust banner initially if language not selected
    // scripts.push({
    //   type: 'text/javascript',
    //   innerHTML: `
    //     (function() {
    //       if (!localStorage.getItem('preferredIso')) {
    //         const style = document.createElement('style');
    //         style.innerHTML = '#onetrust-consent-sdk { display: none !important; }';
    //         style.id = 'onetrust-language-guard';
    //         document.head.appendChild(style);
    //       }
    //     })();
    //   `,
    // });

    try {
      const autoBlock = await fetch(`https://cdn.cookielaw.org/consent/${oneTrustId}/OtAutoBlock.js`);
      const autoBlockContent = await autoBlock.text();

      // inject script inline to save a request
      scripts.push({
        type: 'text/javascript',
        innerHTML: autoBlockContent,
      });
    } catch (e) {
      // if we could not fetch it, that might be because of the browser blocking. So lets add it as a script tag
      scripts.push({
        src: `https://cdn.cookielaw.org/consent/${oneTrustId}/OtAutoBlock.js`,
      });
    }

    scripts.push({
      type: 'text/javascript',
      src: 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js',
      'data-document-language': 'true',
      'data-domain-script': oneTrustId,
      defer: true,
    });

    scripts.push({
      type: 'text/javascript',
      innerHTML: `
        let oneTrustInitialized = false;

        // Helper function to check if cookie exists
        function getCookie(name) {
          const value = "; " + document.cookie;
          const parts = value.split("; " + name + "=");
          if (parts.length === 2) return parts.pop().split(";").shift();
        }

        // SPA function to reload banner on page changes
        function reloadOTBanner() {
          if (!getCookie("OptanonAlertBoxClosed")) {
            if (window.OneTrust != null) {
              // Remove the CSS hiding style
              const hideStyle = document.getElementById('onetrust-language-guard');
              if (hideStyle) {
                hideStyle.remove();
              }

              // Remove existing consent SDK elements
              const existingElements = document.querySelectorAll('#onetrust-consent-sdk, #ot-sdk-cookie-policy');
              existingElements.forEach(el => el.remove());

              OneTrust.Init();
              setTimeout(function() {
                OneTrust.LoadBanner();
              }, 1000);
            }
          }
        }

        // Make reloadOTBanner available globally
        window.reloadOTBanner = reloadOTBanner;

        function OptanonWrapper() {
          // Check if language selection is complete
          const hasSelectedLanguage = localStorage.getItem('preferredIso');
          console.log('OneTrust script loaded', hasSelectedLanguage ? 'with language selection' : 'without language selection');

          // if (!hasSelectedLanguage && window.OneTrust && !oneTrustInitialized) {
          //   oneTrustInitialized = true;
          //   // Set cookie to prevent display
          //   OneTrust.SetAlertBoxClosed();
          // }

          // Dispatch event for other integrations
          window.dispatchEvent(new Event('oneTrustReady'));
        }`,
    });
  }

  if (enableUnbounce && !isStorybook) {
    scripts.push({
      src: 'https://5353afe5db084f38ad5d7caa9c85e3ce.js.ubembed.com',
      defer: true,
    });
  }

  if (enableOptimize && !isStorybook) {
    // ABlfyt Script
    scripts.push({
      type: 'text/javascript',
      src: 'https://cdn.ablyft.com/s/80692412.js',
    });
  }

  if (enableTracify && !isStorybook) {
    const tracifyIds = {
      de: '16684ff7-c87b-43d3-8fde-4a27478faa75',
      fr: '43eb1cdd-97fb-4187-9156-35b1d7053892',
      nl: 'f90ffc5d-fe3c-426b-bab6-153c3be07286',
      en: 'bc8834f4-8638-4302-bf29-966a528630cd',
      'ch-de': '5fbc5ec2-6c4f-4536-ac8d-47bdf8cc0789',
      'ch-fr': '5fbc5ec2-6c4f-4536-ac8d-47bdf8cc0789',
    };

    scripts.push({
      type: 'text/javascript',
      innerHTML: `
      (function() {
        var tracifyLoaded = false;

        window.initTracify = function() {
          if (window.Tracify && !tracifyLoaded) {
            tracifyLoaded = true;
            var tracify = window.Tracify({ csid: "${tracifyIds[locale.value]}"});
            tracify.capturePageView();
          }
        };

        // Load Tracify script
        var script = document.createElement('script');
        script.src = 'https://script.blackroll.com/api.v1.js';
        script.async = true;
        script.onload = function() {
          initTracify();
        };
        document.head.appendChild(script);
      })();
      `,
    });
  }

  useHead({
    script: scripts,
  });
});
